"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = useColumns;
var react_1 = require("react");
var standingsColumns = [
    { name: "Rank", uid: "rank", id: "rank" },
    { name: "Player", uid: "display_name", id: "display_name" },
    { name: "Value", uid: "value", id: "value" },
    { name: "Achieved", uid: "achieved_at", id: "achieved_at" },
];
function useColumns() {
    return (0, react_1.useMemo)(function () { return ({ columns: standingsColumns, headerColumns: standingsColumns }); }, []);
}
